import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import { jsx as _jsx } from "react/jsx-runtime";
function Download(_ref) {
  var Component = _ref.as;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAssetViewerContex = useAssetViewerContext(),
    downloadUrl = _useAssetViewerContex.downloadUrl;
  return /*#__PURE__*/_jsx(Component, {
    icon: "download",
    as: "a",
    href: downloadUrl,
    children: t('actions_download')
  });
}
export default Download;